/** Customer 360 (ALP-79): person page, person quick panel, timeline, notes, people search. Owned by the C360 web track. */
export const people360 = {
  title: "Person",
  back: "Back to people",
  likesLimit: "Instagram doesn't share who liked a post",
  likesLimitHint: "Likes are counted per post, but Instagram never says who liked it, so they can't appear in a person's timeline.",
  openOnInstagram: "Open on Instagram",
  openProfile: "Open full profile",
  openPerson: "Open {{name}}",
  notFound: "This person was not found",
  unknownName: "Instagram user",
  followers: "{{n}} followers",
  header: {
    firstSeen: "First seen {{when}}",
    lastSeen: "Last seen {{when}}",
    mark: "Mark",
    tags: "Tags",
    noTags: "No tags yet",
  },
  stats: {
    title: "At a glance",
    comments: "Comments",
    dms: "Messages",
    replyRate: "Reply rate",
    responseTime: "Avg. response",
    none: "—",
    sentiment: "Sentiment by week",
    sentimentLabel: "Week of {{week}}: {{positive}} positive, {{neutral}} neutral, {{negative}} negative",
    noSentiment: "No sentiment yet",
    accounts: "Accounts they talk to",
    posts: "Posts they commented on",
    postCount: "{{n}} comments",
    interactions: "Interactions: {{n}}",
  },
  timeline: {
    title: "Timeline",
    description: "Every comment, message, reply, AI draft, rule run and team note — newest first.",
    empty: "Nothing here yet",
    emptyFiltered: "Nothing matches these filters",
    loadingMore: "Loading more…",
    end: "That's everything",
    filters: "Timeline filters",
    allAccounts: "All accounts",
    allPosts: "All posts",
    account: "Account",
    post: "Post",
    open: "Open",
    onPost: "on a post",
    groups: { today: "Today", yesterday: "Yesterday", week: "This week", earlier: "Earlier" },
    chips: { all: "All", comments: "Comments", dms: "DMs", automation: "Automation", team: "Team" },
    types: {
      comment: "Commented",
      reply: "We replied",
      dm_in: "Sent a DM",
      dm_out: "We sent a DM",
      reaction: "Reacted to a message",
      story_reply: "Replied to a story",
      mention: "Mentioned the account",
      ai_draft: "AI drafted a reply",
      approval: "Approval",
      automation_run: "Rule ran",
      flag: "Tag added",
      mark: "Marked",
      note: "Team note",
      enrichment: "Public profile fetched",
    },
    states: { hidden: "Hidden", deleted: "Deleted", archived: "Archived", pinned: "Pinned", edited: "Edited" },
    outcome: "Outcome: {{status}}",
    actors: { ai: "AI", automation: "Automation", user: "Team", system: "Malfak", account: "Account" },
    by: "by {{name}}",
  },
  notes: {
    title: "Notes",
    placeholder: "Add a note for the team…",
    add: "Add note",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit note",
    delete: "Delete note",
    deleteConfirm: "Delete this note?",
    empty: "No notes yet",
    readOnly: "Viewers can read notes but not edit them.",
    saved: "Note saved",
    deleted: "Note deleted",
  },
  search: {
    section: "People",
    placeholder: "Search people by @username or name",
    keyword: "Said “{{snippet}}”",
    none: "No people match",
    searching: "Searching…",
    results: "People results",
  },
};
